import { getOriginalPrice, getTestIdsInPromo } from "@/store/modules/va-order-test/helpers/getSeasonalPromos";
import { removeItem } from ".";
import { handleDiscountPanelSelection } from "./discountPanelSelection";
import { handleTestSelection } from "./testSelection";
import { getSampleTypesInPromo } from "../sampleTypes";

export function addSelectedSeasonalPromo(promo, selectProp, supportObj) {
  let { selectedSeasonalPromoList, bundleList, testNodeList } = supportObj;
  // select all applied tests and bundles
  handleSeasonalPromoSelection(promo, selectProp, true, supportObj);
  // get promo's original item
  let testList = testNodeList.map(node => node.value);
  let discountPanelList = bundleList.filter(bundle => bundle.category === "discountPanel");
  promo.originalPrice = getOriginalPrice(promo, discountPanelList, testList).toFixed(2);
  // get testIds in promo
  promo.testIdsInPromo = getTestIdsInPromo(promo, discountPanelList);
  // add sample type for current promo
  promo.sampleTypeSets = getSampleTypesInPromo(promo, testList);
  // add to selected promo list
  selectedSeasonalPromoList.push(promo);
}

export function removeSelectedSeasonalPromo(promo, selectProp, supportObj) {
  let { selectedSeasonalPromoList } = supportObj;
  // de-select all applied tests and bundles
  handleSeasonalPromoSelection(promo, selectProp, false, supportObj); 
  // remove selected promo has the same id as given promo, which is currently stored in selectedSeasonalPromoList
  let removedPromo = selectedSeasonalPromoList.find(p => p.id === promo.id);
  removeItem(removedPromo, selectedSeasonalPromoList);
  if (selectProp === "isSelect") {
    removeSeasonalPromoInEditOrder(promo.id, supportObj.editOrderItemList);
  }
  }

export function handleSeasonalPromoSelection(promo, selectProp, isSelectPromo, supportObj) {
  let { testNodeList, seasonalPromotionList } = supportObj;
  // select/de-select promo according to isSelectPromo value
  // make sure select/de-select the one displayed under promotions section
  promo[selectProp] = isSelectPromo;
  let displayedPromo = seasonalPromotionList.find(p => p.id === promo.id);
  displayedPromo[selectProp] = isSelectPromo;
  promo.appliedTests.forEach(testId => {
    let testNode = testNodeList.find(node => node.id === testId);
    handleTestSelection(testNode, selectProp, isSelectPromo);
  });
  promo.appliedBundles.forEach(bundleId => {
    handleDiscountPanelSelection(bundleId, selectProp, isSelectPromo, supportObj);
  });
}

function removeSeasonalPromoInEditOrder(promoId, editOrderItemList) {
  let promos = editOrderItemList.filter(item => item.item_id === promoId);
  promos.forEach(promo => {
    removeItem(promo, editOrderItemList);
  })
}